import { InputWithSign } from '@/modules/common/components/input-with-sign';
import styles from './index.module.sass';
import { ButtonPrimary } from '@/shared/ui/button';
import { Col, Modal, Row, notification } from 'antd';
import { useEditBuyerFormState } from '@/modules/seller-account/hooks/use-buyer-info.hook';
import { useStore } from 'effector-react';
import {
  $addressOptions,
  $buyersData,
  $requisiteOptions,
  $singleBuyerData,
  deleteBuyerFx,
  fetchBuyerByIdFx,
  fetchBuyersListFx,
  getBuyerById,
  searchBuyersAddressFx,
  searchBuyersRequisitesFx,
  setActiveBuyer,
  updateBuyerFx,
} from '@/modules/seller-account/store/buyers.store';
import { useEffect } from 'react';
import { BuyerInstance } from '@/modules/seller-account/ts';
import md5 from 'md5';
import { useSearchParams } from 'react-router-dom';

export const SettingsTab = ({
  sortOption,
  orderBy,
  searchString,
  setSearchString,
}: {
  sortOption: { label: string; val: string; active: boolean }[];
  orderBy: 'asc' | 'desc';
  searchString: string;
  setSearchString: (val: string) => void;
}) => {
  const { handleChange, formState, setFormState } = useEditBuyerFormState();
  const data = useStore($singleBuyerData);
  const allBuyers = useStore($buyersData);

  const [_, setSearchParams] = useSearchParams();

  const handleDelete = async () => {
    try {
      const res = await deleteBuyerFx(data?.id as number);
      if ('error' in res) {
        if (typeof res.error === 'string')
          return notification.error({ message: res.error });
        const errorRes = res as any;
        const errorArray = Object.keys(errorRes.error.errors).reduce((result, key) => {
          return result.concat(errorRes.error.errors[key]);
        }, []);
        if (errorArray && errorArray.length > 0) {
          errorArray.map((item) => notification.error({ message: item }));
          return;
        }
      }
      // setActiveBuyer(allBuyers.data[0]?.id)
      // setSearchParams({ selected_buyer: String(allBuyers.data[0]?.id) });

      // await fetchBuyerByIdFx({
      //   id: allBuyers.data[0]?.id,
      //   md5: allBuyers.data[0]?.type === 'external' ? md5(allBuyers.data[0]?.company_name) : undefined,
      // });
      getBuyerById(null);
      setSearchParams({});

      fetchBuyersListFx({
        sortBy: sortOption.find((item) => item.active)?.val,
        orderBy,
        search: searchString,
      });
    } catch (err: any) {
      const res = err.body && (await err.json());
      return notification.error({
        message: res.error && 'Непредвиденная ошибка. Попробуйте позже.',
      });
    }

    notification.success({ message: 'Покупатель успешно удален из системы!' });
    // fetchBuyersListFx();
    // window.location.reload();
  };

  const handleUpdate = async () => {
    try {
      const errors = [];
      if (
        !formState.companyName ||
        !formState.address ||
        !formState.country ||
        !formState.phoneNumber ||
        !formState.email
      ) {
        errors.push({
          message: 'Не заполнены обязательные поля',
          description:
            'Поля, отмеченные знаком "*" являются обязательными к заполнению',
        });
      }

      if (formState.companyName.length < 5 || formState.companyName.length > 128) {
        errors.push({
          message: 'Некорректное название компании',
          description: 'Название компании может содержать от 5 до 128 символов',
        });
      }

      if (!formState.email.includes('@') || !formState.email.includes('.')) {
        errors.push({
          message: 'Некорректный email',
          description: 'Email указан в неправильном формате',
        });
      }

      if (
        formState.region === '' ||
        formState.street === '' ||
        formState.house === ''
      ) {
        errors.push({
          message: 'Некорректный адрес',
          description: 'Укажите полный адрес, включая регион, город, дом',
        });
      }

      if (formState.phoneNumber.length !== 12)
        errors.push({
          message: 'Некорректный номер телефона',
          description: 'Номер телефона указан в неправильном формате',
        });

      if (formState.inn && formState.inn.length > 0 && formState.inn.length !== 10) {
        errors.push({
          message: 'Некорректный  ИНН',
          description: 'ИНН должен содержать 10 цифр',
        });
      }

      if (formState.ogrn && formState.ogrn.length > 0 && formState.ogrn.length !== 13) {
        errors.push({
          message: 'Некорректный  ОГРН',
          description: 'ОГРН должен содержать 13 цифр',
        });
      }

      if (errors.length > 0) {
        return errors.map((errItem) => notification.warning(errItem));
      }

      const res = await updateBuyerFx({
        id: data?.id as number,
        data: {
          company_name: formState.companyName,
          country: formState.country,
          address: formState.address,
          email: formState.email,
          inn: formState.inn,
          ogrn: formState.ogrn,
          tel: formState.phoneNumber,
          region: formState.region,
          city: formState.city,
          street: formState.street,
          house: formState.house,
        },
      });
      if ('error' in res) {
        const errorRes = res as any;
        if (errorRes.error) {
          return notification.error({
            message: errorRes.error || 'Непредвиденная ошибка. Попробуйте позже.',
          });
        }
        if (errorRes?.error?.errors) {
          const errorArray = Object.keys(errorRes?.error?.errors).reduce(
            (result, key) => {
              return result.concat(errorRes?.error?.errors[key]);
            },
            [],
          );
          if (errorArray && errorArray.length > 0) {
            errorArray.map((item) => notification.error({ message: item }));
            return;
          }
        } else {
          const errorRes = res as any;
          const resultError = (await errorRes.body) && await errorRes.json();
          return notification.error({
            message: resultError.error || 'Непредвиденная ошибка. Попробуйте позже.',
          });
        }
      }
      notification.success({ message: 'Покупатель обновлен в системе!' });
      fetchBuyerByIdFx({ id: data?.id as number });
      fetchBuyersListFx({
        sortBy: sortOption.find((item) => item.active)?.val,
        orderBy,
        search: searchString,
      });
    } catch (err: any) {
      console.log(err, '--- err')
      const res = (await err.body) && err.json();
      return notification.error({
        message: res.error || 'Непредвиденная ошибка. Попробуйте позже.',
      });
    }
  };

  useEffect(() => {
    if (data) {
      setFormState({
        companyName: data?.company_name,
        country: data?.country,
        address: data?.address,
        email: data?.email,
        inn: data?.inn,
        ogrn: data?.ogrn,
        phoneNumber: data?.tel,
        region: data?.region,
        city: data?.city,
        street: data?.street,
        house: data?.house,
      });
    }
  }, [data]);

  const addressOptions: any = useStore($addressOptions);
  const requisiteOptions: any = useStore($requisiteOptions);
  console.log(requisiteOptions);
  return (
    <div className={styles.root}>
      <h3>информация о компании*</h3>
      {/* <Row gutter={16}>
        <Col span={6}>
          <InputWithSign
            className={classNames(styles.input)}
            value={formState.region}
            postfix=""
            label="область*"
            placeholder=""
            onChange={(e) => {
              handleChange('region', e.target.value);
              searchBuyersAddressFx(formState.region);
            }}
            options={
              Array.isArray(addressOptions)
                ? addressOptions
                    ?.map((item: any) => ({ label: item.region }))
                    .filter(
                      (value: { label: string }, index: number, self: any) =>
                        index ===
                        self.findIndex(
                          (obj: any) => JSON.stringify(obj) === JSON.stringify(value),
                        ),
                    )
                : []
            }
            onOptionSelect={(val: string) => {
              handleChange('region', val);
            }}
          />
        </Col>
        <Col span={6}>
          <InputWithSign
            className={classNames(styles.input)}
            value={formState.city}
            postfix=""
            label="город/населенный пункт*"
            placeholder=""
            onChange={(e) => {
              handleChange('city', e.target.value);
              searchBuyersAddressFx(`${formState.region}, ${formState.city}`);
            }}
            options={
              Array.isArray(addressOptions)
                ? addressOptions
                    ?.map((item: any) => ({ label: item.city }))
                    .filter((item: { label: string }) => item.label)
                    .filter(
                      (value: { label: string }, index: number, self: any) =>
                        index ===
                        self.findIndex(
                          (obj: any) => JSON.stringify(obj) === JSON.stringify(value),
                        ),
                    )
                : []
            }
            onOptionSelect={(val: string) => {
              handleChange('city', val);
            }}
          />
        </Col>
        <Col span={6}>
          <InputWithSign
            className={classNames(styles.input)}
            value={formState.street}
            postfix=""
            label="улица*"
            placeholder=""
            onChange={(e) => {
              handleChange('street', e.target.value);
              searchBuyersAddressFx(
                `${formState.region}, ${formState.city}, ${formState.street}`,
              );
            }}
            options={
              Array.isArray(addressOptions)
                ? addressOptions
                    ?.map((item: any) => ({ label: item.street }))
                    ?.filter((item: { label: string }) => item.label)
                    .filter(
                      (value: { label: string }, index: number, self: any) =>
                        index ===
                        self.findIndex(
                          (obj: any) => JSON.stringify(obj) === JSON.stringify(value),
                        ),
                    )
                : []
            }
            onOptionSelect={(val: string) => {
              handleChange('street', val);
            }}
          />
        </Col>
        <Col span={6}>
          <InputWithSign
            className={classNames(styles.input)}
            value={formState.house}
            postfix=""
            label="дом/павильон*"
            placeholder=""
            onChange={(e) => {
              handleChange('house', e.target.value);
              searchBuyersAddressFx(
                `${formState.region}, ${formState.city}, ${formState.street}, ${formState.house}`,
              );
            }}
            options={
              Array.isArray(addressOptions)
                ? addressOptions
                    ?.map((item: any) => ({ label: item.house }))
                    .filter((item: { label: string }) => item.label)
                    .filter(
                      (value: { label: string }, index: number, self: any) =>
                        index ===
                        self.findIndex(
                          (obj: any) => JSON.stringify(obj) === JSON.stringify(value),
                        ),
                    )
                : []
            }
            onOptionSelect={(val: string) => {
              handleChange('house', val);
            }}
          />
        </Col>
        <Col span={24} style={{ marginTop: '16px', marginBottom: '16px' }}>
          <InputWithSign
            className={classNames(styles.input)}
            value={`${formState.region ? formState.region + ', ' : ''}${
              formState.city ? formState.city + ', ' : ''
            }${formState.street ? formState.street + ', ' : ''}${
              formState.house ?? ''
            }`}
            postfix=""
            placeholder=""
            onChange={() => {}}
          />
        </Col>
      </Row> */}
      <div className={styles.formBlock}>
        <InputWithSign
          className={styles.field}
          value={formState.companyName}
          label="название компании*"
          placeholder=""
          postfix=""
          onChange={(e) => {
            handleChange('companyName', e.target.value);
            searchBuyersRequisitesFx(formState.companyName);
          }}
          options={
            Array.isArray(requisiteOptions)
              ? requisiteOptions
                  ?.map((item: any) => ({ label: item.full_name }))
                  .filter(
                    (value: { label: string }, index: number, self: any) =>
                      index ===
                      self.findIndex(
                        (obj: any) => JSON.stringify(obj) === JSON.stringify(value),
                      ),
                  )
              : []
          }
          onOptionSelect={(val: string) => {
            handleChange('companyName', val);
          }}
        />
        <InputWithSign
          className={styles.field}
          value={formState.address}
          label="адрес*"
          placeholder=""
          postfix=""
          onChange={(e) => {
            handleChange('address', e.target.value);
            searchBuyersAddressFx(`${formState.address}`);
          }}
          options={
            Array.isArray(addressOptions)
              ? addressOptions
                  ?.map((item: any) => ({ label: item.value }))
                  .filter((item: { label: string }) => item.label)
                  .filter(
                    (value: { label: string }, index: number, self: any) =>
                      index ===
                      self.findIndex(
                        (obj: any) => JSON.stringify(obj) === JSON.stringify(value),
                      ),
                  )
              : []
          }
          onOptionSelect={(val: string) => {
            handleChange('address', val);
          }}
        />
        <InputWithSign
          className={styles.field}
          value={formState.phoneNumber}
          label="телефон*"
          placeholder=""
          mask={[
            '+',
            '7',
            ' ',
            '(',
            /[1-9]/,
            /\d/,
            /\d/,
            ')',
            ' ',
            /\d/,
            /\d/,
            /\d/,
            '-',
            /\d/,
            /\d/,
            '-',
            /\d/,
            /\d/,
          ]}
          blocker={false}
          onChange={(e) =>
            handleChange('phoneNumber', e.target.value.replace(/[^\d+]/g, ''))
          }
          postfix=""
        />
        <InputWithSign
          className={styles.field}
          value={formState.email}
          label="e-mail*"
          placeholder=""
          onChange={(e) => handleChange('email', e.target.value)}
          postfix=""
        />
        <InputWithSign
          className={styles.field}
          value={formState.inn}
          label="ИНН"
          placeholder=""
          onChange={(e) => handleChange('inn', e.target.value, 'number')}
          postfix=""
        />
        <InputWithSign
          className={styles.field}
          value={formState.ogrn}
          label="ОГРН"
          placeholder=""
          onChange={(e) => handleChange('ogrn', e.target.value, 'number')}
          postfix=""
        />
      </div>
      <div className={styles.actionBlock}>
        <ButtonPrimary
          label={'сохранить изменения'}
          onClick={() => {
            const errors = [];
            if (
              !formState.companyName ||
              !formState.address ||
              !formState.country ||
              !formState.phoneNumber ||
              !formState.email
            ) {
              errors.push({
                message: 'Не заполнены обязательные поля',
                description:
                  'Поля, отмеченные знаком "*" являются обязательными к заполнению',
              });
            }

            if (
              formState.companyName.length < 5 ||
              formState.companyName.length > 128
            ) {
              errors.push({
                message: 'Некорректное название компании',
                description: 'Название компании может содержать от 5 до 128 символов',
              });
            }

            if (!formState.email.includes('@') || !formState.email.includes('.')) {
              errors.push({
                message: 'Некорректный email',
                description: 'Email указан в неправильном формате',
              });
            }

            if (
              formState.region === '' ||
              formState.street === '' ||
              formState.house === ''
            ) {
              errors.push({
                message: 'Некорректный адрес',
                description: 'Укажите полный адрес, включая регион, город, дом',
              });
            }

            if (formState.phoneNumber.length !== 12)
              errors.push({
                message: 'Некорректный номер телефона',
                description: 'Номер телефона указан в неправильном формате',
              });

            if (
              formState.inn &&
              formState.inn.length > 0 &&
              formState.inn.length !== 10
            ) {
              errors.push({
                message: 'Некорректный  ИНН',
                description: 'ИНН должен содержать 10 цифр',
              });
            }

            if (
              formState.ogrn &&
              formState.ogrn.length > 0 &&
              formState.ogrn.length !== 13
            ) {
              errors.push({
                message: 'Некорректный  ОГРН',
                description: 'ОГРН должен содержать 13 цифр',
              });
            }

            if (errors.length > 0) {
              return errors.map((errItem) => notification.warning(errItem));
            }

            return Modal.confirm({
              title: 'Подтвердите действие',
              content: 'Вы действительно хотите изменить данные покупателя?',
              okText: 'Да',
              cancelText: 'Нет',
              onOk: handleUpdate,
            });
          }}
          className={styles.confirm}
        />
        <ButtonPrimary
          label={'удалить покупателя'}
          onClick={() =>
            Modal.confirm({
              title: 'Подтвердите действие',
              content: 'Вы действительно хотите удалить покупателя?',
              okText: 'Да',
              cancelText: 'Нет',
              onOk: async () => await handleDelete(),
            })
          }
          className={styles.delete}
        />
      </div>
    </div>
  );
};
